import { ReactNode } from "react";
import { Tooltip } from "antd";
import { QuestionCircleOutlined } from "@ant-design/icons";
import { BID_REQUEST_STATUS_ENUM, BidRequestStatus, FeeDetailDto, FeeDetailRole } from "interfaces";
import { isStatusIncluded } from "utils";
import { FeeBreakdown } from "./FeeBreakdown";
import styles from "./feeTooltip.module.css";

const RUB_VISIBLE_STATUSES: BidRequestStatus[] = [
  BID_REQUEST_STATUS_ENUM.FUNDING,
  BID_REQUEST_STATUS_ENUM.AML_CHECK,
  BID_REQUEST_STATUS_ENUM.AML_FAILED,
  BID_REQUEST_STATUS_ENUM.AML_FAILED_REFUNDING,
  BID_REQUEST_STATUS_ENUM.AML_FAILED_REFUNDED,
  BID_REQUEST_STATUS_ENUM.FUNDED,
  BID_REQUEST_STATUS_ENUM.EXECUTION,
  BID_REQUEST_STATUS_ENUM.COMPLETED,
  BID_REQUEST_STATUS_ENUM.CANCELED_REFUNDING,
  BID_REQUEST_STATUS_ENUM.CANCELED_REFUNDED,
  BID_REQUEST_STATUS_ENUM.CANCELED,
];

const AMOUNT_DISCOUNT_VISIBLE_STATUSES: BidRequestStatus[] = [
  BID_REQUEST_STATUS_ENUM.FUNDING,
  BID_REQUEST_STATUS_ENUM.FUNDED,
  BID_REQUEST_STATUS_ENUM.EXECUTION,
  BID_REQUEST_STATUS_ENUM.COMPLETED,
  BID_REQUEST_STATUS_ENUM.CANCELED_REFUNDING,
  BID_REQUEST_STATUS_ENUM.CANCELED_REFUNDED,
  BID_REQUEST_STATUS_ENUM.CANCELED,
];

type Props = {
  value: ReactNode;
  feeDetails: FeeDetailDto[] | undefined;
  role: FeeDetailRole;
  status: BidRequestStatus;
  amountRub: number | undefined;
  totalFee: number;
  totalFeeRub: number | undefined;
  title: string;
  fee: number;
};

export const FeeTooltip = ({
  value,
  feeDetails,
  role,
  status,
  amountRub,
  totalFee,
  totalFeeRub,
  title,
  fee,
}: Props) => {
  const feeDetail = feeDetails?.find((item) => item.role === role);

  if (!feeDetail) {
    return <>{value}</>;
  }

  const showRub = isStatusIncluded(status, RUB_VISIBLE_STATUSES);
  const discountThreshold = feeDetail.discountThreshold;
  const hasAmountRub = amountRub !== undefined && amountRub !== null;
  const hasDiscountThreshold = discountThreshold !== undefined && discountThreshold !== null;
  const showAmountDiscount =
    isStatusIncluded(status, AMOUNT_DISCOUNT_VISIBLE_STATUSES) &&
    hasAmountRub &&
    hasDiscountThreshold &&
    amountRub >= discountThreshold;

  return (
    <span className={styles.wrapper}>
      {value}
      <Tooltip
        title={
          <FeeBreakdown
            title={title}
            fee={fee}
            feeDetail={feeDetail}
            amountRub={amountRub}
            showRub={showRub}
            showAmountDiscount={showAmountDiscount}
            totalFee={totalFee}
            totalFeeRub={totalFeeRub}
          />
        }
        overlayStyle={{ maxWidth: "none" }}
      >
        <QuestionCircleOutlined />
      </Tooltip>
    </span>
  );
};
